<template>
  <div id="DashboardList">
    <b-row class="header-container">
      <b-col xl="7" md="6" sm="12" class="title mb-2">
        All Created Surveys ({{ this.information.length }})
      </b-col>
      <b-col xl="3" md="3" sm="12" class="mb-2">
        <a class="header-all-survey" v-on:click="openModal()">
          SEE ALL SURVEY RESULTS
        </a>
      </b-col>
      <b-col xl="2" md="3" sm="12" class="mb-2">
        <b-dropdown
          id="dropdown-1"
          :text="this.orderList"
          ref="dropdown"
          class="m-md-2"
          :disabled="!this.information.length"
        >
          <TMGeneralButton
            id="buttons"
            @click.native="sortByLatest()"
            text="LATEST"
          />
          <br />
          <TMGeneralButton
            id="buttons"
            @click.native="sortByHighest()"
            text="HIGHEST RESULTS"
          />
          <br />
          <TMGeneralButton
            id="buttons"
            @click.native="sortByLowest()"
            text="LOWEST RESULTS"
          />
        </b-dropdown>
      </b-col>
    </b-row>
    <TMGeneralButton
      text="CREATE SURVEY AND START IMPROVING!"
      className="blue center"
      v-if="!getPresentationMetrics.length"
      route="NewUserPresentation"
    />
    <div class="groups-container">
      <b-row
        class="group-container"
        v-for="(presentation, idx) in this.getPresentationMetrics"
        v-bind:id="'presentation-item-' + presentation.id"
        :key="idx"
      >
        <b-col xl="1" lg="2" md="2" class="responses-container">
          <div class="responses">{{ presentation.respondents }}</div>
          <span>Responses</span>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="12" class="group-detail">
          <div class="group-name">{{ presentation.name }}</div>
          <div class="survey-type">{{ getSurveyTypeString(presentation) }}</div>
          <span>{{ formatDate(presentation.presentation_date) }}</span>
        </b-col>
        <b-col xl="8" lg="6" md="6">
          <b-row class="group-stats-row">
            <b-col xl="6" lg="12" order-xl="1" order-lg="2" order-md="2" order-sm="2" class="group-metrics">
              <div class="area-metrics">
                <div
                  class="score"
                  :style="getColor(Math.round(presentation.metrics.Content) || 0)"
                >
                  {{ Math.round(presentation.metrics.Content) || 0 }}%
                </div>
                <div class="area">Content</div>
              </div>
              <div class="area-metrics">
                <div
                  class="score"
                  :style="getColor(Math.round(presentation.metrics.Visuals) || 0)"
                >
                  {{ Math.round(presentation.metrics.Visuals) || 0 }}%
                </div>
                <div class="area">Visuals</div>
              </div>
              <div class="area-metrics">
                <div
                  class="score"
                  :style="getColor(Math.round(presentation.metrics.Delivery) || 0)"
                >
                  {{ Math.round(presentation.metrics.Delivery) || 0 }}%
                </div>
                <div class="area">Delivery</div>
              </div>
              <div class="area-metrics">
                <div
                  class="score"
                  :style="
                    getColor(Math.round(presentation.metrics.Connection) || 0)
                  "
                >
                  {{ Math.round(presentation.metrics.Connection) || 0 }}%
                </div>
                <div class="area">Connection</div>
              </div>
            </b-col>
            <b-col xl="6" lg="12" order-xl="2" order-lg="1" order-md="1" order-sm="1" class="results">
              <div class="links">
                <a id="mailtosend" :href="getMailtoText(presentation)">
                  <div class="mail"></div>
                </a>
                <a v-on:click="copyToClipboard(presentation)" class="link"></a>
                <p class="sendSurvey top">Send survey again</p>
              </div>
              <div class="button">
                <TMGeneralButton
                  text="SEE RESULTS AND ACTION STEPS"
                  className="blue"
                  route="UserResponses"
                  :routeParams="{ id: presentation.id }"
                  :disabled="!Number(presentation.respondents)"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <DashboardModal
      v-if="isSeeAllSurveyResultAvailable"
      ref="DashboardModal"
      title="All Created Surveys"
      :respondents="100"
      :areas="areas"
      :questions="questions"
    />
  </div>
</template>
<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
import DashboardModal from "@/components/dashboardList/DashboardModal";

import { mapState } from "vuex";
import {
  getAuthorizationToken,
  getTmScoreRangeInformationByValue,
  normalizeQuestionsList,
  formatDate,
} from "@/services/utils";

import Api from "@/services/api";

export default {
  components: { TMGeneralButton, DashboardModal },
  data() {
    return {
      orderList: "LATEST" + Array(30).fill("\xa0").join("") + "▼",
      information: [],
      questions: [],
      areas: {},
    };
  },
  computed: {
    ...mapState(["presentations_metrics", "currentUser"]),
    getPresentationMetrics() {
      var metrics = this.presentations_metrics.map((element) => {
        return {
          ...element,
        };
      });
      this.information = metrics;
      return metrics;
    },
  },
  methods: {
    openModal() {
      let data = [];
      Api()
        .get(`user/presentations/total_respondents_by_score_of_each_question`, {
          params: {
            user_id: this.currentUser.id,
          },
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          if (res.data) {
            data = res.data || [];
            let result = normalizeQuestionsList(data);
            this.areas = result.areas;
            this.questions = result.questions;
            this.$refs.DashboardModal.show();
          }
        })
        .catch((err) => console.log(err));
    },

    isSeeAllSurveyResultAvailable() {
      return this.areas;
    },
    getColor(score) {
      return {
        color: getTmScoreRangeInformationByValue(score).color,
      };
    },
    getSurveyTypeString(presentation) {
      let isOverall = presentation.survey_is_overall == "true"
      let surveyFormat = presentation.survey_format
      if (isOverall) {
        if (surveyFormat == 'in_person') {
          return "Survey for overall presentation skills (in-person)"
        } else {
          return "Survey for overall presentation skills (online)"
        }
      } else {
        if (surveyFormat == 'in_person') {
          return "Survey for a specific presentation skills (in-person)"
        } else {
          return "Survey for a specific presentation skills (online)"
        }
      }

    },
    formatDate: formatDate,
    getMailtoText(data) {
      let localData = JSON.parse(localStorage.getItem("currentUser"));
      var message = encodeURI(data.welcome_message);
      var subject = "Invitation from " + localData.full_name + " to give feedback";

      var path = this.$router.resolve({
        name: "TakeSurvey",
        params: { id: data.id },
      }).href;
      var fullURL = window.location.origin + path;

      return "mailto:?subject=" + subject + "&body=" + message + "%0D%0A%0D%0A" + fullURL + "%0D%0A%0D%0A";
    },
    sortByHighest() {
      this.orderList = "HIGHEST RESULTS" + Array(4).fill("\xa0").join("") + "▼";
      this.information.forEach((presentation) => {
        let sum = Object.keys(presentation.metrics).length
          ? Math.round(presentation.metrics.Content) +
            Math.round(presentation.metrics.Delivery) +
            Math.round(presentation.metrics.Visuals) +
            Math.round(presentation.metrics.Connection)
          : 0;
        presentation.average = sum;
      });
      this.information.sort((a, b) => b.average - a.average);
    },
    sortByLowest() {
      this.orderList = "LOWEST RESULTS" + Array(4).fill("\xa0").join("") + "▼";
      this.information.forEach((presentation) => {
        let sum = Object.keys(presentation.metrics).length
          ? Math.round(presentation.metrics.Content) +
            Math.round(presentation.metrics.Delivery) +
            Math.round(presentation.metrics.Visuals) +
            Math.round(presentation.metrics.Connection)
          : 0;
        presentation.average = sum;
      });
      this.information.sort((a, b) => a.average - b.average);
    },
    sortByLatest() {
      this.orderList = "LATEST" + Array(30).fill("\xa0").join("") + "▼";
      this.information.sort(
        (a, b) => new Date(b.presentation_date) - new Date(a.presentation_date)
      );
    },

    copyToClipboard(item) {
      var path = this.$router.resolve({
        name: "TakeSurvey",
        params: { id: item.id },
      }).href;
      var fullURL = window.location.origin + path;
      try {
        navigator.clipboard.writeText(fullURL);
      } catch (e) {
        throw e;
      }
    },
  },
};
</script>
<style lang="less">
@import "../../assets/components/dashboardAdmin/DashboardList.less";
</style>